export interface CriteriaModel {
	limit: number;
	pageNumber: number;
	filters?: any[];
	location?: any;
	sort?: { field: string, order: number | string };
}

export const LIMIT: number = 12;

export const EmptyCriteria: CriteriaModel = {
	limit: LIMIT,
	pageNumber: 0,
};

export interface CriteriaObject {
	defaultCriteria: any; // cannot be altered and removed
	updatedCrteria: Object; // can be altered and removed
	sortCriteria: Object;
}
